"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.execute = exports.getParamsString = void 0;
const queryString = require("query-string");
const FetchError_1 = require("./FetchError");
const getParamsString = (params) => {
    if (!params) {
        return '';
    }
    const query = queryString.stringify(params, {
        arrayFormat: 'bracket',
        sort: false,
    });
    if (query) {
        return '?' + query;
    }
    return '';
};
exports.getParamsString = getParamsString;
function prepareUrl(apiBase, endpoint, params) {
    if (endpoint.includes('/v2/')) {
        return apiBase.replace('/v1/', '') + endpoint + (0, exports.getParamsString)(params);
    }
    return apiBase + endpoint + (0, exports.getParamsString)(params);
}
function execute(apiLocation_1, shopId_1, bapiCall_1) {
    return __awaiter(this, arguments, void 0, function* (apiLocation, shopId, bapiCall, acceptAllResponseCodes = false, shopIdPlacement = 'query', auth, additionalHeaders) {
        const params = shopIdPlacement === 'query'
            ? Object.assign(Object.assign({}, bapiCall.params), { shopId: shopId }) : bapiCall.params;
        const url = prepareUrl(apiLocation, bapiCall.endpoint, params);
        const shopIdHeader = shopIdPlacement === 'header' ? { 'X-Shop-Id': `${shopId}` } : undefined;
        const response = yield fetch(url, {
            headers: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ Accept: 'application/json', 'Content-Type': 'application/json' }, (typeof window === 'undefined'
                ? { 'accept-encoding': 'gzip, deflate' }
                : undefined)), shopIdHeader), additionalHeaders), (auth && auth.type === 'token' ? { 'X-Access-Token': auth.token } : {})), (auth && auth.type === 'basic'
                ? { Authorization: 'Basic ' + btoa(auth.username + ':' + auth.password) }
                : {})),
            method: bapiCall.method,
            body: bapiCall.method === 'POST' || bapiCall.method === 'PATCH'
                ? JSON.stringify(bapiCall.data)
                : undefined,
        });
        if (!response.ok && !acceptAllResponseCodes) {
            throw new FetchError_1.FetchError(response);
        }
        const headers = {};
        response.headers.forEach((val, key) => (headers[key] = val));
        if (response.status === 204) {
            return {
                data: undefined,
                statusCode: response.status,
                url: response.url || url,
                headers,
            };
        }
        const data = yield response.json();
        if (bapiCall.responseValidator && !bapiCall.responseValidator(data)) {
            throw new Error(`Invalid response data`);
        }
        return {
            data,
            statusCode: response.status,
            url: response.url || url,
            headers,
        };
    });
}
exports.execute = execute;
